import { createFileRoute, Link } from '@tanstack/react-router'
import { Hero } from '@/components/home/hero'
import { RegularLink } from '@/components/inline/RegularLink'
import congregationImage from '@/assets/congregation-holding-up-phones-darksmall.jpg'

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'umi-newsletter-widget': any;
    }
  }
}

export const Route = createFileRoute('/conference/')({
  component: ConferencePage,
})

function ConferencePage() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-stone-50 dark:bg-mist-950 text-stone-900 dark:text-white">

      <main className="flex-grow">

        {/* <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="rounded-xl p-6 shadow-lg" style={{ background: 'linear-gradient(to bottom right, rgb(75, 0, 130), rgb(180, 80, 0))' }}>
            <div className="flex items-start gap-3">
              <span className="text-2xl">👋</span>
              <p className="text-lg text-white font-medium">
                Thanks for exploring our demo at the conference!
              </p>
            </div>
          </div>
        </div> */}

      <section className="px-6 py-12 max-w-5xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight mb-6">
          Thanks for exploring <span className="text-purple-600">Sermon Slides</span>
        </h1>
        <p className="text-xl text-stone-600 dark:text-stone-400 mb-10 max-w-2xl mx-auto leading-relaxed">
          Put your email below, and I will follow up with you after the conference to help you get started with Sermon Slides at your church!
        </p>
      </section>

        {/* Attendee Host split Section */}
        <section className="py-12 max-w-5xl mx-auto px-6 border-t border-stone-100 dark:border-mist-800">
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-top">
            <div className="bg-white dark:bg-mist-900 p-8 rounded-2xl border border-stone-200 dark:border-mist-800 shadow-sm">
              <h2 className="text-3xl font-bold mb-6 text-stone-900 dark:text-white">Attend</h2>
              <p className="text-lg text-stone-600 dark:text-stone-400 mb-4 leading-relaxed">
                Never miss a slide
              </p>

            </div> */}
            <div 
              className="p-8 rounded-2xl border border-stone-200 dark:border-mist-800 shadow-sm text-center"
              style={{
                backgroundImage: `url(${congregationImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <h2 className="text-3xl font-bold py-12 text-white">Stop preaching to a sea of raised phones!</h2>
            </div>
          {/* </div> */}
        </section>

        {/* Newsletter Section */}
        <section className="py-12 max-w-5xl mx-auto px-6 border-t border-stone-100 dark:border-mist-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6 text-stone-900 dark:text-white">We are growing fast</h2>
              <p className="text-lg text-stone-600 dark:text-stone-400 mb-4 leading-relaxed">
                Sermon Slides is in beta testing, and we are partnering with churches and ministries as soon as we are sure you will have the best experience possible.
              </p>
              <p className="text-lg text-stone-600 dark:text-stone-400 leading-relaxed">
                If you are adventurous, or just curious, we promise to only email with important milestones.
              </p>
            </div>
            <div className="bg-white dark:bg-mist-900 p-8 rounded-2xl border border-stone-200 dark:border-mist-800 shadow-sm">
              <umi-newsletter-widget title="Get early access!" product-id="sermon-slides"></umi-newsletter-widget>
            </div>
          </div>
        </section>


        {/* Hero Section */}
        <Hero />

        {/* Attendee Host split Section */}
        <section className="py-20 max-w-5xl mx-auto px-6 border-t border-stone-100 dark:border-mist-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-top">
            <div className="bg-white dark:bg-mist-900 p-8 rounded-2xl border border-stone-200 dark:border-mist-800 shadow-sm">
              <h2 className="text-3xl font-bold mb-6 text-stone-900 dark:text-white">Attend</h2>
              <p className="text-lg text-stone-600 dark:text-stone-400 mb-4 leading-relaxed">
                At participating churches, classrooms, and conferences, you can follow along with the slides on your own device. No more squinting at the big screen or trying to take a picture of the slides!
              </p>
              <p className="text-lg text-stone-600 dark:text-stone-400 leading-relaxed">
                Download our app to get started, or just join online with their code or link!
              </p>
              <p className="text-lg text-stone-600 dark:text-stone-400 leading-relaxed">
                Your church not participating yet? Let them know about Sermon Slides and how it can help your congregation stay engaged!
              </p>
              <p className="text-lg text-stone-600 dark:text-stone-400 leading-relaxed">
                Or, email the creator, <a href="https://unwritten.media/contact/" className="text-purple-600 underline hover:text-purple-400 transition-colors">Marshall</a>, and he will help you get your church or classroom set up with Sermon Slides.
              </p>

            </div>
            <div className="bg-white dark:bg-mist-900 p-8 rounded-2xl border border-stone-200 dark:border-mist-800 shadow-sm">
              <h2 className="text-3xl font-bold mb-6 text-stone-900 dark:text-white">Host</h2>
              <p className="text-lg text-stone-600 dark:text-stone-400 mb-8 leading-relaxed max-w-2xl mx-auto">
                If you lead a classroom, church service, or meeting, you can easily broadcast your slides to your audience's personal devices at the same time as to the projector.
                Keep everyone on the same page and encourage active note-taking.
              </p>
              <p className="text-lg text-stone-600 dark:text-stone-400 mb-8 leading-relaxed max-w-2xl mx-auto">
                No more audience trying to point their cellphones at the screen to take a picture!
              </p>
            </div>
          </div>
        </section>


        {/* Host Section */}
        <section className="bg-gradient-to-br from-purple-50 to-orange-50 dark:from-purple-950/30 dark:to-orange-950/30 py-20 border-y border-stone-200 dark:border-mist-800">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold mb-6 text-stone-900 dark:text-white">Want to share your own slides?</h2>
            <p className="text-lg text-stone-600 dark:text-stone-400 mb-8 leading-relaxed max-w-2xl mx-auto">
              If you lead a classroom, church service, or meeting, you can easily broadcast your slides to your audience's personal devices at the same time as to the projector.
              Keep everyone on the same page and encourage active note-taking.
            </p>
            <p className="text-lg text-stone-600 dark:text-stone-400 mb-8 leading-relaxed max-w-2xl mx-auto">
              No more audience trying to point their cellphones at the screen to take a picture!
            </p>
            <div className="flex justify-center gap-4">
              <Link to="/signup" className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5">
                Create Free Account
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 max-w-3xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-10 text-center text-stone-900 dark:text-white">Frequently Asked Questions</h2>
          <div className="space-y-4">
            <details className="group bg-white dark:bg-mist-900 border border-stone-200 dark:border-mist-800 rounded-xl overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer items-center justify-between gap-1.5 p-6 text-stone-900 dark:text-white font-medium">
                <h3 className="text-lg">Do attendees need to download an app?</h3>
                <span className="shrink-0 rounded-full bg-purple-50 dark:bg-purple-950/40 p-1.5 text-purple-700 group-open:-rotate-180 transition-transform duration-300">
                  <svg xmlns="http://www.w3.org/2000/svg" className="size-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </summary>
              <div className="px-6 pb-6 pt-0 text-stone-600 dark:text-stone-400 leading-relaxed">
                No, participants can just enter the joining code on this website through their mobile browser. No downloads required!
              </div>
            </details>

            <details className="group bg-white dark:bg-mist-900 border border-stone-200 dark:border-mist-800 rounded-xl overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer items-center justify-between gap-1.5 p-6 text-stone-900 dark:text-white font-medium">
                <h3 className="text-lg">Does it integrate with ProPresenter or PowerPoint?</h3>
                <span className="shrink-0 rounded-full bg-purple-50 dark:bg-purple-950/40 p-1.5 text-purple-700 group-open:-rotate-180 transition-transform duration-300">
                  <svg xmlns="http://www.w3.org/2000/svg" className="size-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </summary>
              <div className="px-6 pb-6 pt-0 text-stone-600 dark:text-stone-400 leading-relaxed">
                Yes! Our desktop software captures your presentation output seamlessly and syncs it to the cloud in real-time.
              </div>
            </details>

            <details className="group bg-white dark:bg-mist-900 border border-stone-200 dark:border-mist-800 rounded-xl overflow-hidden [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer items-center justify-between gap-1.5 p-6 text-stone-900 dark:text-white font-medium">
                <h3 className="text-lg">How much does it cost?</h3>
                <span className="shrink-0 rounded-full bg-purple-50 dark:bg-purple-950/40 p-1.5 text-purple-700 group-open:-rotate-180 transition-transform duration-300">
                  <svg xmlns="http://www.w3.org/2000/svg" className="size-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </summary>
              <div className="px-6 pb-6 pt-0 text-stone-600 dark:text-stone-400 leading-relaxed">
                We offer a free tier for small groups. For larger congregations and classrooms, we have affordable premium plans to support higher concurrency.
              </div>
            </details>
          </div>
        </section>

        {/* Training Section */}
        <section className="bg-stone-900 text-white py-16">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-2xl font-bold mb-4">Want to learn more?</h2>
            <p className="text-stone-300 dark:text-mist-600 mb-8 max-w-2xl mx-auto">
              Check out our comprehensive documentation to learn how to set up your screens, cameras, and configure integrations for the best note-taking experience.
            </p>
            <a href="https://learn.sermon-slides.com/docs" className="inline-flex items-center gap-2 border border-stone-500 hover:border-white hover:bg-stone-800 dark:bg-mist-700 text-white px-6 py-3 rounded-lg font-medium transition-colors">
              Read the Documentation
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-white dark:bg-mist-900 border-t border-stone-200 dark:border-mist-800 py-10">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-stone-800 dark:text-stone-100 font-bold">
            <span className="w-6 h-6 rounded-full bg-gradient-to-br from-purple-600 to-orange-500 flex-shrink-0"></span>
            Sermon Slides
          </div>
          <div className="text-stone-500 dark:text-mist-400 text-sm">
            &copy; {new Date().getFullYear()} Sermon Slides &amp; <RegularLink href="https://unwritten.media">Unwritten Media</RegularLink>. All rights reserved.
          </div>
          <div className="flex gap-6 text-sm font-medium text-stone-500 dark:text-mist-400">
            <RegularLink to="/faq">FAQ</RegularLink>
            <RegularLink to="/faq/privacy">Privacy</RegularLink>
            <RegularLink to="/faq/terms">Terms</RegularLink>
            <RegularLink href="mailto:support@sermon-slides.com">Contact</RegularLink>
          </div>
        </div>
      </footer>
    </div>
  )
}
